/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global Network, snackbar, FormValidation, lng, schema */

/**
 *
 * @param {Rest} rest
 * @returns {Table}
 */
function RestTable(rest) {
  if (!this instanceof RestTable) return new RestTable(rest);

  //TODO build filter by schema options

  /**
   * Main Element with controlls and anything you need
   * @type Element
   */
  this.node = document.createElement("div");
  this._itemsPerPage = 10;
  this._page = 0;
  this._total = null;
  this._search = "";
  this._columns = [];
  this._newload = true;
  this._unfilteredData = [];

  //not used, but helpfull for error logging
  this._data;

  this.onclick = function (row) {
    console.warn("Click on row. Overwrite onlick()!");
  };
  this.oncreate = function (instance) {
    console.warn("Create new instance. Overwrite oncreate()!");
  };

  this.toPage = toPage;
  this.refresh = refresh;
  this.inactivecheck = true;
  this.sortItem = -1;
  const that = this;
  const pointer = {
    /**
     * @type Element
     */
    thead: null,
    /**
     * @type Element
     */
    tbody: null,
  };

  if (globalData.user) {
    prepareColumns();
    buildWrapper();
    buildTHeader();
    toPage(0);
  } else {
  }

  /**
   * Process the <i>options.columns</i> to able use some querying.
   * Some Examples:
   * <ul>
   * <li><i>login</i> Simple name. Will be used as label also as the key of each object.</li>
   * <li><i>support:manage_partner</i> First the label. After the <i>:</i> is the query. In this case a simple key.</li>
   * <li><i>manager of:partnerGroupManager.name</i> Use the <i>name</i> property of <i>partnerGroup</i></li>
   * <li><i>manager of:partnerGroupManager[].name</i> Concat all <i>name<i> properties of all objects in <i>partnerGroup</i> array.
   * Currently is no syntax for the concat symbol. Default: ", "</li>
   * </ul>
   * The result will be in the original variable. Will be an array of objects with the following structure.
   * <i>name, key, sub, subIsArray</i>.
   * <ul>
   * <li><i>name</i> label</li>
   * <li><i>key</i> key to use. Never <i>null</i></li>
   * <li><i>sub</i> key to inside the object in <i>key</i>. Could be <i>null</i></li>
   * <li><i>subIsArray</i> is <i>true</i> if property in <i>key</i> is array.</li>
   * </ul>
   * @returns {undefined}
   */
  function prepareColumns() {
    for (let key in rest.schemaData) {
      let schemaItem = rest.schemaData[key];

      //schemaItems without label schould not be displayed
      if (!schemaItem.label || schemaItem.hideInTable) continue;

      let col = {
        key: key,
        label: schemaItem.label,
        sortable:
          schemaItem.sortable !== undefined ? schemaItem.sortable : true,
      };

      if (!schemaItem.getString) {
        //default function is to simply use the key

        col.getString = (row) => {
          let val = row[key];

          //parse date
          if (schemaItem.type === "date" && val)
            return new Date(val).toLocaleDateString();

          //parse datetime
          if (schemaItem.type === "datetime" && val)
            return new Date(val).toLocaleString();

          //parse true, false, undefined
          switch (val) {
            case true:
              return schema.ICONS.DONE;
              break;
            case null:
            case false:
            case undefined:
              return "";
              break;
            default:
              return val + "";
          }
        };
      } else {
        col.getString = (row) => schemaItem.getString(row);
      }
      that._columns.push(col);
    }
  }

  /**
   * Fill the <i>thead tr</i> with <i>th</i> elements by <i>options.columns</i>.
   * <i>prepareColumns()</i> is required to called before this.
   * @returns {undefined}
   */
  function buildTHeader() {
    const theadTr = pointer.thead.children[0];
    const columns = that._columns;

    let i = 0;
    const len = columns.length;
    for (; i < len; i++) {
      const col = columns[i];

      //create th
      const th = document.createElement("th");
      th.textContent = col.label;
      th.classList.add("mdl-data-table__cell--non-numeric");

      //check if some search attribute starts with col.key
      if (
        rest.searchAttributes.filter((sa) => sa.indexOf(col.key) === 0).length >
        0
      )
        th.classList.add("searchable");

      //append tr to table head
      theadTr.appendChild(th);

      if (col.sortable) {
        th.onclick = (function () {
          const key = col.key;
          const item = i;
          return function () {
            sortTable(key, item);
          };
        })();
        th.insertAdjacentHTML(
          "beforeend",
          '<i class="material-icons">code</i>'
        );
      } else {
        th.classList.add("no-icon");
        th.insertAdjacentHTML(
          "beforeend",
          '<i class="material-icons">remove</i>'
        );
      }
    }
  }

  function sortData(item, desc) {
    return function (a, b) {
      if (a[item] === undefined && b[item] === undefined) return 0;
      if (a[item] === b[item]) return 0;
      if (desc) {
        if (a[item] === undefined) return -1;
        if (b[item] === undefined) return 1;
        if (Array.isArray(a[item]) && Array.isArray(b[item])) {
          if (a[item].length === b[item].length) return 0;
          if (a[item].length < b[item].length) return -1;
          return 1;
        }
        if (
          typeof a[item] === "object" &&
          a[item] !== null &&
          typeof b[item] === "object" &&
          b[item] !== null
        ) {
          if (
            a[item].hasOwnProperty("name") &&
            b[item].hasOwnProperty("name")
          ) {
            var keyA = a[item]["name"].toLowerCase();
            var keyB = b[item]["name"].toLowerCase();
            if (keyA === keyB) return 0;
            if (keyA < keyB) return -1;
            return 1;
          }
        }
        if (a[item] < b[item]) return -1;
        return 1;
      } else {
        if (a[item] === undefined) return 1;
        if (b[item] === undefined) return -1;
        if (Array.isArray(a[item]) && Array.isArray(b[item])) {
          if (a[item].length === b[item].length) return 0;
          if (a[item].length < b[item].length) return 1;
          return -1;
        }
        if (
          typeof a[item] === "object" &&
          a[item] !== null &&
          typeof b[item] === "object" &&
          b[item] !== null
        ) {
          if (
            a[item].hasOwnProperty("name") &&
            b[item].hasOwnProperty("name")
          ) {
            var keyA = a[item]["name"].toLowerCase();
            var keyB = b[item]["name"].toLowerCase();
            if (keyA === keyB) return 0;
            if (keyA < keyB) return 1;
            return -1;
          }
        }
        if (a[item] < b[item]) return 1;
        return -1;
      }
    };
  }

  function sortTable(key, item) {
    const tr = that.node.querySelector("table thead tr");
    that._data.sort(sortData(key, that.sortOrder));

    const oldItem = that.sortItem % that._columns.length;
    let oldOrder = that.sortItem - that._columns.length > -1;
    if (that._total > 0) {
      if (oldItem === item) {
        if (!oldOrder) {
          let i = tr.children[item].querySelector("i");
          i.innerHTML = "keyboard_arrow_left";
          that._data.sort(sortData(key, false));
          that.sortItem = item + that._columns.length;
        } else {
          let i = tr.children[item].querySelector("i");
          i.innerHTML = "keyboard_arrow_right";
          that._data.sort(sortData(key, true));
          that.sortItem = item;
        }
      } else {
        let i = tr.children[item].querySelector("i");
        i.innerHTML = "keyboard_arrow_right";
        that.sortItem = item;
        that._data.sort(sortData(key, true));
      }

      for (let y = 0; y < tr.children.length; y++) {
        let i = tr.children[y].querySelector("i");
        if (y !== item && i) i.innerHTML = "code";
      }

      toPage(that._page);
    }
  }

  function toPage(page) {
    if (that._itemsPerPage < 0) page = 0;
    else if (
      (page < 0 || page > Math.floor(that._total / that._itemsPerPage)) &&
      that._total !== null
    )
      return;
    if (that._newload) {
      request(page)
        .then((data) => {
          if (rest.schemaKey === "form") {
            // manual search for the partners in forms
            let filteredData = [];

            if (data.length > 0 && that._search.length === 0) {
              that._unfilteredData = data;
            }
            if (that._search.length > 0) {
              if (
                data.length === 0 &&
                that._unfilteredData &&
                that._unfilteredData.length > 0
              ) {
                data = that._unfilteredData;
                data.forEach((dataObject) => {
                  if (
                    dataObject.formPartner[0] &&
                    dataObject.formPartner[0].partner &&
                    dataObject.formPartner[0].partner.name
                      .toLowerCase()
                      .indexOf(that._search.toLowerCase()) >= 0
                  ) {
                    filteredData.push(dataObject);
                  } else if (
                    dataObject.name
                      .toLowerCase()
                      .indexOf(that._search.toLowerCase()) >= 0
                  ) {
                    filteredData.push(dataObject);
                  }
                });
              } else {
                that._unfilteredData.forEach((dataObject) => {
                  if (
                    dataObject.formPartner[0] &&
                    dataObject.formPartner[0].partner &&
                    dataObject.formPartner[0].partner.name
                      .toLowerCase()
                      .indexOf(that._search.toLowerCase()) >= 0
                  ) {
                    filteredData.push(dataObject);
                  } else if (
                    dataObject.name
                      .toLowerCase()
                      .indexOf(that._search.toLowerCase()) >= 0
                  ) {
                    filteredData.push(dataObject);
                  }
                });
                data.forEach((dataObject) => {
                  let contains = false;
                  filteredData.forEach((dataObj) => {
                    if (
                      dataObject.name === dataObj.name &&
                      dataObject.version === dataObj.version
                    )
                      contains = true;
                  });
                  if (!contains) filteredData.push(dataObject);
                });
              }
            } else {
              filteredData = data;
            }

            that._page = page;
            that._newload = false;
            draw(filteredData);
            pageButtons();
          } else {
            that._page = page;
            that._newload = false;
            draw(data);
            pageButtons();
          }
        })
        .catch((e) => {
          draw([]);
          if (e instanceof Error && !(typeof e === "number")) throw e;
          snackbar.show({
            message: lng.get(e),
          });
        });
    } else {
      that._page = page;
      draw(that._data);
      pageButtons();
    }
  }

  function refresh() {
    that._newload = true;
    toPage(0);
  }

  function request(page) {
    const findQuery = {
      populate: "", //pop all
    };

    if (rest.schema.label === "Partner") findQuery.nostreetschema = true;

    if (rest.schema.partner) findQuery.nostreetschema = true;

    findQuery.sort = "updatedAt DESC";

    if (that.inactivecheck === true && rest.schema.label !== "Verträge")
      findQuery.where = { active: true };
    else findQuery.where = {};

    if (that._search) {
      findQuery.search = that._search;
      return rest.textSearch(findQuery);
    }
    return rest.find(findQuery);
  }

  /**
   * Build the Wrapper, Tablehead and user controls.
   * @returns {Element}
   */
  function buildWrapper() {
    const wrapper = that.node;
    that.inactivecheck = true;
    wrapper.classList.add("rest-table");
    wrapper.insertAdjacentHTML(
      "beforeend",
      `
            <header>
                <div class="items-prer-page">
                    <label>Ergebnisse pro Seite</label>
                    <select>
                        <option>10</option>
                        <option>20</option>
                        <option>50</option>
                        <option value="-1">Alle</option>
                    </select>
                </div>
                <h2 class="title"></h2>
                <input name="search" placeholder="Suche"><br>
            </header>
            <header2>
                <input type="checkbox" class="inactivebox" value="notactive" checked>
                    Inaktive ausblenden
                </input>
            </header2>
            <table class="mdl-data-table mdl-js-data-table">
              <thead>
                <tr>
                </tr>
              </thead>
              <tbody>
              </tbody>
            </table>
            <footer>
              <div class="current-number">
                <label class="current"></label> von <label class="total"></label>
              </div>
              <div class="footer-buttons">
                <button class="add mdl-button mdl-js-button mdl-button--raised mdl-button--colored">Hinzufügen</button>
              </div>
              <div class="pageing">
                <button class="prev">Zurück</button>
                <div class="generated"></div>
                <button class="next">Vor</button>
              </div>
            </footer>`
    );

    pointer.thead = wrapper.querySelector("thead");
    pointer.tbody = wrapper.querySelector("tbody");

    //isactive checkbox
    wrapper
      .querySelector("header2 .inactivebox")
      .addEventListener("change", function (e) {
        that.inactivecheck = !that.inactivecheck;
        refresh();
      });

    const lbl = rest.schema.label;

    if (lbl === "Benutzer") {
      that.inactivecheck = false;
      wrapper.querySelector("header2").style.display = "none";
    }
    //items per page
    wrapper
      .querySelector("header .items-prer-page select")
      .addEventListener("change", function (e) {
        let val = parseInt(this.value, 10);

        // -- try to jump to right page --
        let targetPage = 0;
        if (that._itemsPerPage > 0 && val > 0) {
          //makes no sense if all items were or will be visible
          const firstVisibleElementIndex = that._itemsPerPage * that._page;
          targetPage = parseInt(firstVisibleElementIndex / val, 10);
        } else {
          val = 10000;
          targetPage = 0;
        }

        that._itemsPerPage = val;
        toPage(targetPage);
      });

    //title
    wrapper.querySelector("header .title").textContent = rest.schema.label;

    //textsearch
    const searchInput = wrapper.querySelector("header input[name=search]");
    FormValidation.delayedTextInput(searchInput, function (value) {
      that._search = value;
      that._newload = true;
      toPage(0);
    });
    searchInput.addEventListener("focus", function () {
      pointer.thead.classList.add("in-search");
    });
    searchInput.addEventListener("blur", function () {
      pointer.thead.classList.remove("in-search");
    });

    //pageing
    wrapper
      .querySelector("footer .pageing button.prev")
      .addEventListener("click", function (e) {
        toPage(that._page - 1);
      });
    wrapper
      .querySelector("footer .pageing button.next")
      .addEventListener("click", function (e) {
        toPage(that._page + 1);
      });

    //create new instance
    const addButton = wrapper.querySelector("footer button.add");
    if (!rest.schema.accessCreate || rest.schema.accessCreate()) {
      if (rest.schemaKey === "automaticExport") {
        // Add another button to the footer
        //<button class="add mdl-button mdl-js-button mdl-button--raised mdl-button--colored">Hinzufügen</button>
        const historyButton = document.createElement("button");
        historyButton.classList.add(
          "mdl-button",
          "mdl-js-button",
          "mdl-button--raised",
          "mdl-button--colored",
          "history-button"
        );
        historyButton.innerText = "Export-Historie";
        addButton.parentElement.appendChild(historyButton);

        const historyDiv = document.createElement("div");
        historyDiv.classList.add("history-modal", "modal");
        that.node.appendChild(historyDiv);
        that.historyModal = new HistoryModal(that.node);
        that.historyModal.loadJson();

        historyButton.addEventListener("click", () => {
          that.historyModal.toggleModal();
        });
      }

      addButton.addEventListener("click", function (e) {
        that.oncreate(rest.createEmptyInstance());
      });
    } else {
      addButton.style.display = "none";
    }
  }

  function draw(data) {
    data = data.filter((element) => {
      return !(
        that.inactivecheck &&
        (element.active === false || element.canceled === true)
      );
    });

    that._data = data;
    that._total = data.length;
    const columns = that._columns;
    const itemsPerPage = that._itemsPerPage;
    const page = that._page;
    const tbody = pointer.tbody;
    tbody.innerHTML = null;

    that.node.querySelector("footer .current-number .total").textContent =
      that._total;

    let i = itemsPerPage * page;
    const len = data.length;
    for (; i < len && i < itemsPerPage * (page + 1); i++) {
      let row = data[i];

      let tr = document.createElement("tr");
      tr.data = row; //for easer debuging
      tr.addEventListener("click", function (e) {
        //Reset to 10 entries per page!
        const val = parseInt(10, 10);
        const selecter = that.node.querySelector(
          "header .items-prer-page select"
        );
        selecter.value = 10;

        // -- try to jump to right page --
        let targetPage = 0;
        if (that._itemsPerPage > 0 && val > 0) {
          //makes no sense if all items were or will be visible
          const firstVisibleElementIndex = that._itemsPerPage * that._page;
          targetPage = parseInt(firstVisibleElementIndex / val, 10);
        }

        that._itemsPerPage = val;
        toPage(targetPage);

        that.onclick(row);
      });

      let j = 0;
      const len2 = columns.length;

      for (; j < len2; j++) {
        let col = columns[j];

        const td = document.createElement("td");
        td.classList.add("mdl-data-table__cell--non-numeric");
        td.insertAdjacentHTML("beforeend", col.getString(row) || "");
        tr.appendChild(td);
      }
      tbody.appendChild(tr);
    }

    let startN;
    if (that._itemsPerPage > 0) startN = that._page * that._itemsPerPage + 1;
    else startN = 1;
    const dif = (i - 1) % itemsPerPage;
    that.node.querySelector("footer .current-number .current").textContent =
      startN + " bis " + (startN + dif);
  }

  function pageButtons() {
    const buttonWrapper = that.node.querySelector("footer .pageing .generated");

    /**
     * Number of page buttons before and after the current.
     * @type Number
     */
    const range = 2;

    buttonWrapper.innerHTML = null;

    let lastPage;
    if (that._itemsPerPage > 0)
      lastPage = Math.floor((that._total - 1) / that._itemsPerPage);
    else lastPage = 0;
    const startAt = Math.max(0, that._page - range);

    if (startAt > 0) {
      genButton(0);
      if (startAt > 1)
        buttonWrapper.appendChild(document.createTextNode("..."));
    }

    let i;
    for (i = startAt; i <= Math.min(that._page + range, lastPage); i++)
      genButton(i);

    i--;
    if (i < lastPage) {
      if (i + 1 < lastPage)
        buttonWrapper.appendChild(document.createTextNode("..."));
      genButton(lastPage);
    }

    function genButton(page) {
      const button = document.createElement("button");
      button.textContent = page + 1;
      button.addEventListener("click", function (e) {
        that.toPage(page);
      });
      buttonWrapper.appendChild(button);
    }
  }
}
